import { render, staticRenderFns, recyclableRender, components } from "./product-management.vue?vue&type=template&id=3cbf15c0&scoped=true&"
var renderjs
import script from "./product-management.vue?vue&type=script&lang=js&"
export * from "./product-management.vue?vue&type=script&lang=js&"
import style0 from "./product-management.vue?vue&type=style&index=0&lang=css&"
import style1 from "./product-management.vue?vue&type=style&index=1&id=3cbf15c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbf15c0",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pagesA/pages/product-management/product-management.vue"
export default component.exports